import UserDetail from './UserDetail';

export default UserDetail;



// WEBPACK FOOTER //
// ./src/scenes/Users/UserDetail/index.ts